var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m1zl1c8gla",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u9s2nnj52b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m1zl1c8gla)",
    d: "M0 3.771c0-.703.192-1.102.671-1.566L2.157.735C2.637.272 3.037 0 3.74 0H7c.911 0 1.343.4 1.934.99l8.198 8.262c.863.88.847 1.71.016 2.541l-5.306 5.338c-.847.83-1.694.847-2.573-.032L.991 8.885C.4 8.325 0 7.895 0 6.967V3.771z",
    transform: "translate(-277 -495) translate(261 478) translate(16 12) translate(0 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u9s2nnj52b)",
    stroke: "url(#u9s2nnj52b)",
    strokeWidth: 0.75,
    d: "M5.02 3.372c.41 0 .82.154 1.13.474.303.314.46.727.46 1.14 0 .41-.153.817-.464 1.128-.313.313-.72.465-1.13.461-.406-.003-.816-.162-1.142-.477-.316-.315-.476-.726-.476-1.136 0-.406.157-.812.476-1.12.306-.307.725-.47 1.146-.47z",
    transform: "translate(-277 -495) translate(261 478) translate(16 12) translate(0 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcDiscount);
export default __webpack_public_path__ + "static/media/customer-ic-discount.4b5c166e.svg";
export { ForwardRef as ReactComponent };